import { SearchParamType } from "./types/SearchParamType";
export function normalizeJobCategorySuids(values) {
    var normalizedValues = Array.from(values, function (value) { return value.trim(); }).filter(function (value) { return value.length > 0; });
    return Array.from(new Set(normalizedValues));
}
export function getJobCategorySuids(searchParams) {
    return normalizeJobCategorySuids(searchParams.getAll(SearchParamType.JOB_CATEGORY_SUID));
}
export function setJobCategorySuids(searchParams, values) {
    searchParams.delete(SearchParamType.JOB_CATEGORY_SUID);
    normalizeJobCategorySuids(values).forEach(function (value) {
        searchParams.append(SearchParamType.JOB_CATEGORY_SUID, value);
    });
}
